import React, { useState, useEffect, useCallback } from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import { Snackbar } from '@material-ui/core';

function Alert(props:any) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
interface IAlert {
    setOpen: (e: any) => void;
    setSeverity: (e: any) => void;
    setAlertMessage: (e: any) => void;
};
// export const ToastAlert = ({setOpen,setSeverity,setAlertMessage}:IAlert) => {
export const ToastAlert = (props:any) => {

    const {open,severity,alertMessage}=props;

    // const [openI, setOpen] = React.useState(open);
    // const [severityI, setSeverity] = React.useState(severity);
    // const [alertMessageI, setAlertMessage] = React.useState(alertMessage);

    const handleClose = (event:any, reason:any) => {
        console.log("H1e")
        if (reason === 'clickaway') {
        return;
        }

        // setOpen(false);
    };
    return (
    //    { open?
    //         (<Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
    //             <Alert onClose={handleClose} severity={severity}>
    //                 {alertMessage}
    //             </Alert>
    //         </Snackbar>)
    //         :null
    //     }
    <>
    {
        // open ? <h1>Esta open</h1> : <h1>Esta open</h1>
        open?
            (<Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity}>
                    {alertMessage}
                </Alert>
            </Snackbar>)
            :null
    }
    </>
    )
    
}